import { createRouteFor } from '@components-common/routes';
export const sectionBase = "assignments";
export const routeId = ":assignmentId";
export const routeIdBase = `${sectionBase}/:assignmentId`;
export const basePath = sectionBase;

export const members = `/${routeIdBase}/members`;
export const students = `/${routeIdBase}/students`;
export const lecturers = `/${routeIdBase}/lecturers`;
export const resources = `/${routeIdBase}/resources`;
export const assignments = `/${routeIdBase}/submissions`;


const routesForAssignments = createRouteFor<typeof routeIdBase,"assignments">(routeIdBase,"assignments");

export const assignmentRoutes = {
  index: routesForAssignments("index",{basePath:""}),
  create: routesForAssignments("create",{basePath:""}),
  details: routesForAssignments("details",{basePath:":assignmentId"}),
}

export type AssignmentsRoutesIds = typeof assignmentRoutes[keyof typeof assignmentRoutes]["id"];
